import React, { useState } from "react";
import { Drawer, Stack } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import InfoRow from "../../../../components/atoms/InfoRow";
import FormTextField from "../../../../components/atoms/FormTextField";
import DrawerHeader from "../../../../components/atoms/DrawerHeader";
import DrawerFooter from "../../../../components/atoms/DrawerFooter";
import { COLORS, TYPO } from "../../../../styles/uiConstants";

export default function FreeUploadDrawer({ open, onClose, clinic, onSubmit, isLoading }) {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  const canSubmit = Number(amount) > 0 && reason.trim();

  const handleSubmit = () =>
    onSubmit({ amount: Number(amount), reason: reason.trim() });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 440 } } }}
    >
      <DrawerHeader
        icon={<CardGiftcardIcon />}
        title="Ücretsiz Token Yükle"
        subtitle={clinic?.name}
        onClose={onClose}
        bgcolor={COLORS.success}
      />

      <Stack spacing={0} sx={{ p: 0, flex: 1, overflowY: "auto" }}>
        <InfoRow label="Miktar (token)">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            type="number"
            fullWidth
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 1 }}
          />
        </InfoRow>
        <InfoRow label="Sebep">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            multiline
            fullWidth
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 500 }}
            placeholder="Deneme sürümü, telafi, vb."
          />
        </InfoRow>
      </Stack>

      <DrawerFooter
        onCancel={onClose}
        onSubmit={handleSubmit}
        submitLabel="Yükle"
        loading={isLoading}
        disabled={!canSubmit}
        submitColor="primary"
        fullWidth
      />
    </Drawer>
  );
}
